import React from "react";
import { PackageCheck, RefreshCcw } from "lucide-react";

export default function InventoryHeader({
  onRefresh,
  borderColor,
  title = "Warehouse Inventory",
  description = "Manage active stock, review expired batches separately, raise order requests to admin, and receive inbound stock batches from approved receipts.",
}) {
  return (
    <div
      className="rounded-[20px] border bg-white p-6 shadow-[0_12px_30px_rgba(216,106,120,0.08)]"
      style={{ borderColor: borderColor }}
    >
      <div className="flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex items-start gap-4">
          <div className="grid h-12 w-12 shrink-0 place-items-center rounded-[14px] bg-[#fff6f7] text-[#d86a78]">
            <PackageCheck size={22} />
          </div>

          <div>
            <h2 className="warehouse-page-title">{title}</h2>
            <p className="mt-2 max-w-2xl text-[14px] leading-6 text-slate-500">
              {description}
            </p>
          </div>
        </div>

        <button
          type="button"
          onClick={onRefresh}
          className="inline-flex items-center gap-2 rounded-[12px] border border-[#f2c6cc] px-4 py-2 text-[13px] font-semibold text-slate-600 transition hover:bg-[#fff8f9] hover:text-[#d86a78]"
        >
          <RefreshCcw size={16} />
          Refresh
        </button>
      </div>
    </div>
  );
}
